var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdd({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.16669 8.16666V4.83332H9.83335V8.16666H13.1667V9.83332H9.83335V13.1667H8.16669V9.83332H4.83335V8.16666H8.16669ZM9.00002 17.3333C4.39752 17.3333 0.666687 13.6025 0.666687 8.99999C0.666687 4.39749 4.39752 0.666656 9.00002 0.666656C13.6025 0.666656 17.3334 4.39749 17.3334 8.99999C17.3334 13.6025 13.6025 17.3333 9.00002 17.3333ZM9.00002 15.6667C10.7681 15.6667 12.4638 14.9643 13.7141 13.714C14.9643 12.4638 15.6667 10.7681 15.6667 8.99999C15.6667 7.23188 14.9643 5.53619 13.7141 4.28594C12.4638 3.0357 10.7681 2.33332 9.00002 2.33332C7.23191 2.33332 5.53622 3.0357 4.28598 4.28594C3.03573 5.53619 2.33335 7.23188 2.33335 8.99999C2.33335 10.7681 3.03573 12.4638 4.28598 13.714C5.53622 14.9643 7.23191 15.6667 9.00002 15.6667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdd);
export default __webpack_public_path__ + "static/media/add.636f28b087207d5d4740cc9123133c7a.svg";
export { ForwardRef as ReactComponent };